import { avatarPlaceholder, type AvatarKey } from '@hazel/shared'

/**
 * What to do when a teddy's photograph is not there.
 *
 * Falls back to the drawing before giving up, so a teddy whose photograph has
 * not been taken yet still looks like himself. Ten cards on a memory board
 * where one is a blank reads as broken; ten where one is still a drawing reads
 * as a collection half-photographed, which is what it is.
 */
/** The path part of whatever the browser says the src is. */
function pathOf(src: string): string {
  try {
    return new URL(src, window.location.href).pathname
  } catch {
    return src
  }
}

export function fallBackToDrawing(
  image: HTMLImageElement,
  teddy: AvatarKey,
  onGone?: () => void,
): void {
  const drawing = avatarPlaceholder(teddy)

  // Compared as a path rather than by how the string ends. The browser reports
  // src as an absolute URL, so it needs parsing either way — and `endsWith`
  // would also be fooled by a cache-busting query string, or by a teddy whose
  // filename happens to end with another's.
  if (pathOf(image.src) !== drawing) {
    image.src = drawing
    return
  }

  // The drawing is missing too, which means nothing is coming.
  if (onGone) onGone()
  else image.style.display = 'none'
}
